import React, { useEffect, useState } from "react";
import "./CarImageModal.css";

export const CAR_IMAGE_VIEWS = [
  "front",
  "side",
  "rear",
  "inside",
  "boot",
  "screen",
];

interface Props {
  images: string[];
  initialIndex: number;
  alt: string;
  onClose: () => void;
}

const CarImageModal: React.FC<Props> = ({ images, initialIndex, alt, onClose }) => {
  const [activeIndex, setActiveIndex] = useState(initialIndex);

  const showPrevious = () => {
    setActiveIndex((index) => (index - 1 + images.length) % images.length);
  };

  const showNext = () => {
    setActiveIndex((index) => (index + 1) % images.length);
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "ArrowLeft") {
        setActiveIndex((index) => (index - 1 + images.length) % images.length);
      }
      if (event.key === "ArrowRight") {
        setActiveIndex((index) => (index + 1) % images.length);
      }
      if (event.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [images.length, onClose]);

  if (images.length === 0) return null;

  return (
    <div className="modal is-active car-image-modal" role="dialog" aria-modal="true" aria-label="Car image gallery">
      <div className="modal-background" onClick={onClose}></div>
      <div className="modal-content car-image-modal-content">
        <div className="car-image-main">
          <button
            className="car-image-arrow car-image-arrow-previous"
            type="button"
            aria-label="Previous image"
            onClick={showPrevious}
          >
            <i className="fas fa-chevron-left" aria-hidden="true"></i>
          </button>
          <img src={`images/${images[activeIndex]}`} alt={`${alt} (${activeIndex + 1})`} />
          <button
            className="car-image-arrow car-image-arrow-next"
            type="button"
            aria-label="Next image"
            onClick={showNext}
          >
            <i className="fas fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
        <div className="car-image-thumbnails" aria-label="Choose an image">
          {images.map((image, index) => (
            <button
              className={`car-image-thumbnail${index === activeIndex ? " is-active" : ""}`}
              type="button"
              key={`${image}-${index}`}
              aria-label={`Show image ${index + 1}`}
              aria-pressed={index === activeIndex}
              onClick={() => setActiveIndex(index)}
            >
              <img src={`images/${image}`} alt="" />
            </button>
          ))}
        </div>
      </div>
      <button className="modal-close is-large" aria-label="Close image gallery" onClick={onClose}></button>
    </div>
  );
};

export default CarImageModal;